export class TimeoutError extends Error {
  constructor(
    message: string,
    public url: string,
    public attempts: number
  ) {
    super(message);
    this.name = 'TimeoutError';
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}

export class NotFoundError extends Error {
  constructor(
    message: string,
    public url: string,
    public status: number = 404
  ) {
    super(message);
    this.name = 'NotFoundError';
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}

export class NetworkError extends Error {
  constructor(
    message: string,
    public url: string,
    public status?: number
  ) {
    super(message);
    this.name = 'NetworkError';
    Object.setPrototypeOf(this, NetworkError.prototype);
  }
}

export class ModuleLoadError extends Error {
  constructor(
    message: string,
    public moduleName: string,
    public originalError?: Error
  ) {
    super(message);
    this.name = 'ModuleLoadError';
    Object.setPrototypeOf(this, ModuleLoadError.prototype);
  }
}
